import { IrelandH7ImportDeclaration } from 'store/declarations/ireland/h7-import-declaration';
import {
    getCustomerValidation,
    getEoriValidation,
    getExactLengthValidation,
    getFloatValidation,
    getMaxValidation,
    getNumberOfItemsValidation,
    getRequiredMessage,
    Shape,
} from 'views/declarations/utils/validation-utils';
import * as Yup from 'yup';
import { governmentAgencyGoodsItem } from './H7ProductValidationSchema';
import { valuationInformation } from './H7CommonValidations';
import { h7Box44KeyNames } from 'views/declarations/common/box44/mappers';
import { getDocumentsValidationSchema } from '../../utils';

// fiscal reference card validation is in its own component

export const supportingDocumentSchema = getDocumentsValidationSchema({
    documentTypeKey: h7Box44KeyNames.documentType,
    documentIdentifierKey: h7Box44KeyNames.documentIdentifier,
    measurementKey: h7Box44KeyNames.measurement as string,
    monetaryAmountKey: h7Box44KeyNames.monetaryAmount as string,
});

const h7Validation = (numberOfItems?: number) =>
    Yup.object().shape<Shape<IrelandH7ImportDeclaration>>({
        numberOfItems: getNumberOfItemsValidation(numberOfItems)
            .required(getRequiredMessage('numberOfItems'))
            .nullable()
            .template(),
        additionalDeclarationType: getMaxValidation('additionalDeclarationType', 3)
            .required(getRequiredMessage('additionalDeclarationType'))
            .nullable()
            .template(),
        customsOfficeLodgement: getExactLengthValidation('customsOfficeOfLodgement', 8)
            .required(getRequiredMessage('customsOfficeOfLodgement'))
            .nullable()
            .template(),
        deferredPayment: getMaxValidation('deferredPayment', 35).nullable().template(),
        preferredPaymentMethod: getExactLengthValidation('preferredPaymentMethod', 1).nullable().template(),
        representativeIdentificationNumber: getEoriValidation('representativeIdentificationNumber'),
        representativeStatus: getExactLengthValidation('representativeStatus', 1).nullable().template(),
        goodsShipment: Yup.object()
            .shape({
                governmentAgencyGoodsItem: Yup.array()
                    .of(governmentAgencyGoodsItem)
                    .required(getRequiredMessage('governmentAgencyGoodsItem'))
                    .template()
                    .nullable(),
                valuationInformation: valuationInformation,
                exporter: getCustomerValidation({ postCode: { max: 17 } }).nullable(),
                importer: getCustomerValidation({ postCode: { max: 17 } }).nullable(),
                locationOfGoodsTypeOfLocation: getExactLengthValidation('locationOfGoodsTypeOfLocation', 1)
                    .template()
                    .nullable(),
                locationOfGoodsQualifierOfIdentification: getExactLengthValidation(
                    'locationOfGoodsQualifierOfIdentification',
                    1
                )
                    .template()
                    .nullable(),
                locationOfGoodsUnlocode: getMaxValidation('locationOfGoodsUnlocode', 17).template().nullable(),
                locationOfGoodsAdditionalIdentifier: getMaxValidation('locationOfGoodsAdditionalIdentifier', 4)
                    .template()
                    .nullable(),
                locationOfGoodsAddress: Yup.object({
                    postCode: getMaxValidation('postCode', 17).template().nullable(),
                    streetAndNumber: getMaxValidation('streetAndNumber', 70).template().nullable(),
                    city: getMaxValidation('city', 35).template().nullable(),
                    country: getMaxValidation('country', 2).template().nullable(),
                }).nullable(),
                documentsAuthorisations: Yup.object({
                    referenceNumberUcr: getMaxValidation('referenceNumberUcr', 35).template().nullable(),
                    supportingDocument: supportingDocumentSchema,
                }).nullable(),
                grossMass: getFloatValidation('grossMass', 16, 6).template().nullable(),
            })
            .required('Goods Shipment is required')
            .nullable(),
        declarant: getCustomerValidation({ eori: { required: true }, postCode: { max: 17 } }).nullable(),
    });

export default h7Validation;
